export default {
  title: "المواد الخطرة",
  subtitle: "إدارة المواد الخطرة",
  
  breadcrumbs: {
    dangerousItems: "المواد الخطرة"
  },
  
  table: {
    name: "الاسم",
    price: "السعر",
    actions: "خيارات الأوامر"
  },
  
  actions: {
    add: "إضافة مادة جديدة",
    edit: "تعديل",
    delete: "حذف",
    refresh: "تحديث",
    export: "تصدير",
    search: "البحث في المواد الخطرة...",
    filter: "تصفية"
  },
  
  messages: {
    fetchError: "خطأ في جلب المواد الخطرة",
    deleteSuccess: "تم حذف المادة بنجاح",
    deleteError: "خطأ في حذف المادة",
    deleteConfirm: "هل أنت متأكد من حذف هذه المادة؟",
    noItems: "لا توجد مواد",
    loading: "جاري تحميل المواد الخطرة..."
  },
  
  form: {
    name: "اسم المادة",
    price: "السعر",
    description: "الوصف",
    category: "التصنيف",
    status: "الحالة"
  },
  
  placeholders: {
    name: "أدخل اسم المادة",
    price: "أدخل السعر",
    description: "أدخل الوصف",
    search: "البحث بالاسم أو السعر..."
  },
  
  validation: {
    nameRequired: "اسم المادة مطلوب",
    priceRequired: "السعر مطلوب",
    invalidPrice: "يرجى إدخال سعر صحيح",
    negativePrice: "لا يمكن أن يكون السعر سالباً"
  },
  
  status: {
    active: "نشط",
    inactive: "غير نشط"
  }
};
